<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Roles</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Personal</a>
        </li>
        <li class="breadcrumb-item active">Roles</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button type="button" class="btn btn-theme" @click="openModal('register', '')">Nuevo</button>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <input v-model="search" type="text" class="form-control" placeholder="Ingrese el nombre del rol" @keyup="fetchData(1,search,critery, checkboxmanual)">
              <button type="submit" class="btn btn-theme" @click="fetchData(1,search,critery, checkboxmanual)"><i class="icon-fa icon-fa-search"/> Buscar</button>
            </div><br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                v-model="checkboxmanual"
                type="checkbox"
                class="custom-control-input"
                required
                @change="fetchData(1, search, critery, checkboxmanual)"
              >
              <label v-if="checkboxmanual === false" class="custom-control-label" for="customControlValidation1">
                Mostrar datos inactivos
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar datos activos
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
          </div>
        </div>
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="roles in arrayRole" :key="roles.id">
              <td v-text="roles.name"/>
              <td>
                <span v-if="roles.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td v-text="showDate(roles.created_at)"/>
              <td>
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group"
                  >
                    <router-link v-tooltip.top-center="'Ver permisos'" :to="`/admin/personas/permisos?item=${roles.id}`" class="btn btn-primary btn-block"><i class="icon-fa icon-fa-eye"/></router-link>

                    <button v-tooltip.top-center="'Editar rol'" v-if="roles.name !== 'Administrador'" class="btn btn-theme" @click="openModal('update', roles)"><i class="icon-fa icon-fa-pencil"/></button>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Desactivar rol'" v-if="roles.state==1" class="btn btn-danger" @click="openModal('deactivate', roles)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar rol'" v-else class="btn btn-info" @click="openModal('activate', roles)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, critery, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, critery, checkboxmanual)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, critery, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Tabla maquetada por Arturo y Pedro-->
      </div>

      <!-- MODALES -->
      <sweet-modal ref="role_modal" :title="titleModal" hide-close-button blocking>
        <!-- START FORM -->
        <div class="card-body">
          <div class="form-group">
            <label>Nombre</label>
            <input
              :class="{ 'is-invalid': $v.name.$error }"
              v-model.trim="name"
              class="form-control"
              @input="$v.name.$touch()"
            >
            <div v-if="$v.name.$error">
              <span
                v-if="!$v.name.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
        </div>
        <!-- END FORM -->

        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveRole()"
        >Guardar</button>
        <button
          v-if="typeAction == 2"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="updateRole()"
        >Actualizar</button>
      </sweet-modal>
      <sweet-modal
        ref="activar_modal"
        icon="info"
      >
        {{ tituloModalActivar }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activar_modal.close()"
        >
          No
        </button>
        <button
          v-if="typeAction == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="deactivateRole()"
        >
          Si
        </button>
        <button
          v-if="typeAction == 4"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activateRole()"
        >
          Si
        </button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import ladda from 'ladda'

export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      tabrol: false,
      tabpermisos: true,
      arrayRole: [],
      titleModal: '',
      checkboxmanual: false,
      name: '',
      id: 0,
      typeAction: 1,
      tituloModalActivar: '',
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      offset: 3,
      item: 'name',
      search: '',
      critery: '',
      role: {
        id: 0,
        state: 1,
        name: ''
      }
    }
  },
  validations () {
    if (this.tabrol === false) {
      return {
        name: {
          required
        }
      }
    }
    if (this.tabpermisos === false) {
      // if(this.arrayDetalle.length === 0){
      return {
        name: {

        }
      }
      // }
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.search, this.item, this.checkboxmanual)
  },
  methods: {
    showDate (date) {
      return moment(date).locale('es').format('LLL')
    },
    changePage (page, search, item, checkboxmanual) {
      let me = this
      me.pagination.current_page = page
      me.fetchData(page, search, item, checkboxmanual)
    },
    async fetchData (page, search, item, checkboxmanual) {
      let me = this
      // eslint-disable-next-line no-unused-vars
      const response =
      // eslint-disable-next-line no-undef
      await axios
        .get(
          `/api/admin/roles/get?page=${page}&search=${search}&item=${item}&checkboxmanual=${checkboxmanual}`
        )
        .then(function (response) {
          var respuesta = response.data
          me.arrayRole = respuesta.roles.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveRole () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios
          .post('/api/admin/roles/', {
            name: this.name
          })
          .then(function (response) {
            toastr.success('Rol guardado', 'Éxito')
            l.stop()
            me.role.id = response.data.message
            me.$router.push(`/admin/personas/rolpermisos?item=${me.role.id}`)
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    updateRole () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios
          .put('/api/admin/roles/update', {
            name: this.name,
            id: this.id
          })
          .then(function (response) {
            toastr.success(response.data.message, 'Éxito')
            l.stop()
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    activateRole () {
      let me = this
      axios.put('/api/admin/roles/activate', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    deactivateRole () {
      let me = this
      axios.put('/api/admin/roles/deactivate', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    openModal (accion, data = []) {
      this.$v.$reset()
      let me = this
      switch (accion) {
        case 'register': {
          me.$refs.role_modal.open()
          this.titleModal = 'Nuevo rol'
          this.name = ''
          this.typeAction = 1
          break
        }
        case 'update': {
          me.$refs.role_modal.open()
          this.titleModal = 'Actualizar rol'
          this.id = data['id']
          this.name = data['name']
          this.typeAction = 2
          break
        }
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea desactivar el rol?'
          this.id = data['id']
          this.typeAction = 3
          break
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea activar el rol?'
          this.id = data['id']
          this.typeAction = 4
          break
        }
      }
    },
    closeModal () {
      this.$refs.role_modal.close()
      this.name = ''
      this.titleModal = ''
      this.tituloModalActivar = ''
      this.$refs.activar_modal.close()
      this.$v.$reset()
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.checkboxmanual)
      this.tabrol = false
      this.tabpermisos = true
    },
    validarTecla: function (e) {
      if (e.keyCode === 13) {
        if (this.typeAction === 1) {
          this.saveRole()
        } else if (this.typeAction === 2) {
          this.updateRole()
        }
      } else if (e.keyCode === 50) {
        console.log('@ was pressed')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/persons/Role.vue